<div class="registration-layout">
  <img alt="imagedetails" [src]="'logos/logo.svg' | contentAssetImage" class="logo" />
  <div class="registration-container">
    <router-outlet></router-outlet>
  </div>
</div>
